<template lang="pug">
  v-stepper(v-model="e1")
    v-stepper-header
      v-stepper-step(:complete="e1 > 1" step="1") Detail Izin
      v-divider
      v-stepper-step(:complete="e1 > 2" step="2") Detail Pekerjaan
      v-divider
      v-stepper-step(:complete="e1 > 3" step="3") Pencegahan/Persyaratan Khusus

    v-stepper-items
      v-stepper-content(step="1")
        v-card(class="mb-12"
          height="auto")
            v-layout(row wrap)
              v-flex(xs3 sm3) 
                br
                p(class="headerSection") Tanggal
              v-flex(xs4 sm2)
                v-menu(
                  v-model="startMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px")
                
                  template(v-slot:activator="{ on }")
                    v-text-field(
                      v-model="startDate"
                      label="mulai dari"
                      prepend-icon="event"
                      readonly
                      v-on="on")
                  v-date-picker(v-model="startDate" @input="clearDate" :min="todayDate")
              v-flex(xs4 sm2)
                v-menu(
                  v-model="endMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px")
                
                  template(v-slot:activator="{ on }")
                    v-text-field(
                      v-model="endDate"
                      label="sampai dengan"
                      prepend-icon="event"
                      readonly
                      v-on="on")
                  v-date-picker(v-model="endDate" @input="endMenu = false" :min="startDate")
              v-flex(xs1 sm4)
              
              v-flex(xs4 sm3) 
                p(class="headerSection") Kontraktor / Subkontraktor
              v-flex(xs7 sm5)
                v-autocomplete(
                  class="inputDefault"
                  v-model="perusahaan"
                  :items="dataUsers.companies"
                  label="Kontraktor/Subkontraktor")
              v-flex(xs1 sm4)

              v-flex(xs4 sm3) 
                br
                p(class="headerSection") Nama Pemegang Izin
              v-flex(xs7 sm5)
                v-menu(
                  v-model="searchPemegangMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px")
                
                  template(v-slot:activator="{ on }")
                    v-text-field(
                      v-model="pemegangIzin.name"
                      label="Pemegang Izin"
                      readonly
                      v-on="on")
                  PemegangModal(:searchPemegang="searchPemegangMenu" @interface="searchPemegangMenu = false" @selectedUser="updatePemegangIzin")
              v-flex(xs1 sm4)

              v-flex(xs4 sm3) 
                p(class="headerSection") Lokasi kerja
              v-flex(xs7 sm5)
                  //- v-text-field(class="inputDefault" v-model='pemegangIzin')
                  v-autocomplete(
                    label="Lokasi kerja" 
                    v-model="lokasi" 
                    :items="locations.data" 
                    no-data-text="No Data" 
                    color="blue-grey lighten-2" 
                    item-text="location_name" 
                    item-value="data" 
                    clearable
                    chips
                    multiple)
              v-flex(xs1 sm4)
              //- v-flex(xs9 sm9)
                //- v-layout(row wrap)
                  div(v-for="(item, index) in locations" :key="index")
                    v-checkbox(class="locationOptions" v-model="lokasi[index]" :label="item.name")

              //- v-flex(xs3 sm3) 
              //-   p(class="headerSection") Nomor Izin Kerja
              //- v-flex(xs5 sm5)
              //-   v-text-field(class="inputDefault" v-model='nomorIzinKerja')
              //- v-flex(xs4 sm4)
              v-flex(xs4 sm3)
                p(class="headerSection") Detail Lokasi
              v-flex(xs7 sm5)
                v-text-field(class="inputDefault" v-model='detailLokasi')
              v-flex(xs1 sm4)

              v-flex(xs4 sm3) 
                p(class="headerSection") Jam dikeluarkan izin
              v-flex(xs7 sm5)
                v-text-field(prepend-icon="access_time" class="inputDefault" placeholder="HH:mm" hint="HH:mm" v-model='waktuMulaiMask' v-mask="'##:##'")
                //- v-menu(
                //-   v-model="startHourMenu"
                //-   :close-on-content-click="false"
                //-   :nudge-right="40"
                //-   transition="scale-transition"
                //-   offset-y
                //-   min-width="290px")
                
                //-   template(v-slot:activator="{ on }")
                //-     v-text-field(
                //-       v-model="jamBerlakuIzin"
                //-       label="Jam Dikeluarkan Izin"
                //-       prepend-icon="event"
                //-       readonly
                //-       v-on="on")
                //-   v-time-picker(v-model="jamBerlakuIzin" @input="clearTime")
              v-flex(xs1 sm4)

              v-flex(xs4 sm3) 
                p(class="headerSection") Jam berakhir izin
              v-flex(xs7 sm5)
                v-text-field(prepend-icon="access_time" class="inputDefault" placeholder="HH:mm" hint="HH:mm" v-model='waktuSelesaiMask' v-mask="'##:##'")
                //- v-menu(
                //-   v-model="endHourMenu"
                //-   :close-on-content-click="false"
                //-   :nudge-right="40"
                //-   transition="scale-transition"
                //-   offset-y
                //-   min-width="290px")
                
                //-   template(v-slot:activator="{ on }")
                //-     v-text-field(
                //-       v-model="jamBerakhirIzin"
                //-       label="Jam Berakhir Izin"
                //-       prepend-icon="event"
                //-       readonly
                //-       v-on="on")
                //-   v-time-picker(v-model="jamBerakhirIzin" :min="jamBerlakuIzin" )
              v-flex(xs1 sm4)
             
        v-btn(color="primary" @click="e1 = 2; scrollTop();" :disabled='!isPage1Complete') Continue
        v-btn(text @click="backHome()") Cancel

      v-stepper-content(step="2")
        v-card(class="mb-12"
          height="auto")
            v-layout(row wrap)

              v-flex(xs12 sm12) 
                  h3(class="headerSection") Detail Pekerjaan
                  br
              v-flex( sm12)
                  div(style="margin: 0 15px 0 15px;padding: 0;}")
                    ckeditor(:editor="editor" v-model="detailPekerjaan" :config="editorConfig")
                  br
                                
        v-btn(class="mr-3" dark color='blue-grey' @click="backStep();scrollTop();") BACK
        v-btn(color="primary" @click="e1 = 3; scrollTop();") Continue
        v-btn(text @click="backHome()") Cancel

      v-stepper-content(step="3")
        v-card(class="mb-12"
        height="auto")
          v-layout(row wrap)
            //-Done
            v-flex(xs12 sm12) 
              h3(class="headerSection") Daftar Periksa
              br
            //-   h3(class="headerSection") A. Pengelasan dengan Acetylene dan Oxygen/Argon
            v-flex(xs5 sm6)
              p(class="headerInput") Ada prosedur kerja (PPO, IK, AKA)?
            v-flex(xs1 sm2)
            v-flex(xs5 sm3)
              v-select(class="selectInput" :items='checkOptions' v-model="prosedurKerja" label="Pilih" clearable) 
            //-Done
            v-flex(xs5 sm6)
              p(class="headerInput") Prosedur sudah disosialisasikan?
            v-flex(xs1 sm2)
            v-flex(xs5 sm3)
              v-select(class="selectInput" :items='checkOptions' v-model="sosialisasiProsedur" label="Pilih" clearable) 
            //-Done
            v-flex(xs5 sm6)
              p(class="headerInput") Pekerja kompeten / ada penunjukan KTT?
            v-flex(xs1 sm2)
            v-flex(xs5 sm3)
              v-select(class="selectInput" :items='checkOptions' v-model="kompetenKTT" label="Pilih" clearable) 
            //-Done
            v-flex(xs5 sm6)
              p(class="headerInput") Logger ada izin dari BAPETEN?
            v-flex(xs1 sm2)
            v-flex(xs5 sm3)
              v-select(class="selectInput" :items='checkOptions' v-model="izinBAPETEN" label="Pilih" clearable) 
            //-Done
            v-flex(xs5 sm6)
              p(class="headerInput") Alat Pelindung Diri tersedia?
            v-flex(xs1 sm2)
            v-flex(xs5 sm3)
              v-select(class="selectInput" :items='checkOptions' v-model="APD" label="Pilih" clearable) 
            //-Done
            v-flex(xs5 sm6)
              p(class="headerInput") Ada alat pelindung diri khusus?
            v-flex(xs1 sm2)
            v-flex(xs5 sm3)
              v-select(class="selectInput" :items='checkOptions' v-model="APDKhusus" label="Pilih" clearable) 
            //-Done
            v-flex(xs5 sm6)
              p(class="headerInput") Hasil inspeksi peralatan?
            v-flex(xs1 sm2)
            v-flex(xs5 sm3)
              v-select(class="selectInput" :items='checkOptions' v-model="inspeksiPeralatan" label="Pilih" clearable) 
            //-Done
            v-flex(xs5 sm6)
              p(class="headerInput") Ada Dosimeter / TLD? 
            v-flex(xs1 sm2)
            v-flex(xs5 sm3)
              v-select(class="selectInput" :items='checkOptions' v-model="dosimeterTLD" label="Pilih" clearable) 

            v-flex(xs12 sm12)
              br

            v-flex(xs5 sm3) 
              h3(class="headerSection") Upload Dokumen
            v-flex(xs6 sm5 class="attachment" v-if="!docPendukung || docPendukung.size > 10000000")
              v-file-input(:rules="rules"  label="Hanya 1 file, max 10MB" v-model="docPendukung")
                template(v-slot:selection="{ text }" )
                  v-chip(small label color="primary")   {{ text }}
            v-flex(xs6 sm5 class="attachmentName" v-if="(docPendukung)||(docPendukung && docPendukung.size < 10000000)")
              span {{docPendukung.name ? docPendukung.name : docName(docPendukung) }}
              v-btn(icon color="red" @click="deleteDocPendukung('docPendukung')")
                v-icon mdi-close
            v-flex(xs1 sm4)

            v-flex(xs12 sm12)
              br

            v-flex(xs12 sm12) 
              h3(class="headerSection") Tindakan Pencegahan Lainnya
              br
            v-flex( sm12)
              div(style="margin: 0 15px 0 15px;padding: 0;}")
                ckeditor(:editor="editor2" v-model="tindakanPencegahan" :config="editorConfig")
                br

        v-btn(class="mr-3" dark color='blue-grey' @click='backStep()') BACK
        v-btn(class="mr-3" color='info' @click='submit(1)')
          v-icon insert_drive_file
          | &nbsp; Save as Draft
        v-btn(v-if='!submitClick' color='success' @click='submit(2)')
          v-icon send
          | &nbsp; Submit Request
        v-btn(text @click="backHome()") Cancel

        //- v-btn(class="mr-3" dark color='blue-grey' @click='backStep()') BACK
        //- v-btn(color="primary" @click="e1 = 4; scrollTop();") Continue
        //- v-btn(text @click="backHome()") Cancel

    
        
</template>

<script>
import helper from "../helper/index.js";
import axios from "axios";
import { mapState } from "vuex";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { MyCustomUploadAdapterPlugin } from "../utils/MyUploadAdapter";
import PemegangModal from "./PemegangModal.vue";
export default {
  name: "AddKerjaRadioaktif",
  components: {
    PemegangModal
  },
  props: {
    edit: { type: Boolean, default: false },
    users: Array
  },
  data() {
    return {
      editor: ClassicEditor,
      editor2: ClassicEditor,
      editorConfig: {
        extraPlugins: [ MyCustomUploadAdapterPlugin ],
        removePlugins : ['ImageUpload','MediaEmbed'],
        toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'indent', 'outdent', '|', 'blockQuote', 'insertTable', 'undo', 'redo'],
        image: {
          // You need to configure the image toolbar, too, so it uses the new style buttons.
          toolbar: [ 'imageTextAlternative', '|', 'imageStyle:alignLeft', 'imageStyle:full', 'imageStyle:alignRight' ],
          styles: [
              // This option is equal to a situation where no style is applied.
              'full',
              // This represents an image aligned to the left.
              'alignLeft',
              // This represents an image aligned to the right.
              'alignRight'
          ]
        }
      }, 
      searchPemegangMenu: false,     
      tindakanPencegahan:'',
      detailPekerjaan:'',
      pemegangIzin:'',
      // nomorIzinKerja: '',
      jamBerlakuIzin:'',
      jamBerakhirIzin:'',

      dosimeterTLD:'',
      inspeksiPeralatan:'',
      APDKhusus:'',
      prosedurKerja:'',
      APD:'',
      perusahaan: '',
      izinBAPETEN:'',
      kompetenKTT:'',
      sosialisasiProsedur:'',
      
      e1: 1,
      forms: '',
      formCode: 'BIB-HSE-PPO-FRM-036-005',
      tanggal : Date(Date.now()),
      todayDate: new Date().toISOString().slice(0,10),
      companies: ['PT. ABCDE','PT. FGHIJ','PT. KLMNO','PT. PQRSTU','PT. VWXYZ'],
      lokasi: [],
      detailLokasi: '',
      startDate: null,
      endDate: null,
      startMenu: false,
      startHourMenu: false,
      endHourMenu: false,
      endMenu: false,
      startDateExtend: new Date().toISOString().substr(0, 10),
      endDateExtend: new Date().toISOString().substr(0, 10),
      startMenuExtend: false,
      endMenuExtend: false,
      checkOptions: ['Ya', 'Tidak'],
      file: '',
      uploadId: null,
      personalFile: null,
      docPendukung: null,
      submitClick: false,
      status: 0,
      rules: [
        value => !value || value.size < 10000000 || 'Ukuran file harus dibawah 10 MB!',
      ],
      emptyUpload: new File([""], "", {
                type: "",
              })
    };
  },
  mounted: async function() {
    this.$store.dispatch("fetchLocations");
    axios.get(`${this.API_URL}/form/getforms?name=Izin_Kerja_di_Ketinggian`).then((res) => {
      if (res.status == 200) {
        this.forms = res.data;
      }
    });    
    this.uploadId = Date.now();
  },
  computed: {
    ...mapState(["API_URL", "locations", "dataUsers", "dataEditRequest"]),
    selectedLoc(){
      let tempLoc = []
      let locationCode;
      
      if(this.dataUsers.location instanceof Array){
        locationCode = this.dataUsers.location[0];
      }else{
        locationCode = this.dataUsers.location;
      }

      for(let i = 0; i < this.lokasi.length; i++){
        tempLoc.push({code: locationCode, name: this.lokasi[i]});
      }
      return tempLoc
    },
    waktuSelesaiMask: {
      get() {
        return this.jamBerakhirIzin;
      },
      set(value){
        this.jamBerakhirIzin = this.filterTime(value);
      }
    },
    waktuMulaiMask: {
      get() {
        return this.jamBerlakuIzin;
      },
      set(value){
        this.jamBerlakuIzin = this.filterTime(value);
      }
    },
    isPage1Complete: function() {
      return !!this.perusahaan && !!this.pemegangIzin && !(this.selectedLoc.length<1) && !!this.detailLokasi && !!this.startDate && !!this.endDate && !(this.jamBerlakuIzin.length < 5) && !(this.jamBerakhirIzin.length < 5);
      // return !!this.perusahaan && !!this.startDate && !!this.endDate && (this.selectedLoc.length != 0)  && !!this.pemegangIzin && !!this.jamBerlakuIzin && !!this.jamBerakhirIzin;
    },
    // isPage2Complete: function() {
    //   return !!this.detailPekerjaan;
    // }
  },
  methods: {
    updatePemegangIzin(user) {
      this.pemegangIzin = user;
    },
    filterTime(value) {
      let temp = value.split('');
      if(parseInt(temp[0]) > 2) {
        temp[0] = "2";
      }
      if(parseInt(temp[1]) > 3 && parseInt(temp[0]) == 2) {
        temp[1] = "3";
      }
      if(parseInt(temp[3]) > 5) {
        temp[3] = "5";
      }
      return temp.join('');
    },
    clearTime() {
      this.jamBerakhirIzin = '';
    },
    clearDate(){
      this.endDate=null;
      this.startMenu = false;
    },
    formatDate:helper.formatDate,
    scrollTop(){
      window.scrollTo(0,0);
    },
    submit(status){
      this.submitClick = true;
      this.status = status;

      let formData = new FormData();
      if (this.edit) {
        formData.append('_id', this.dataEditRequest._id);
        formData.append('ipNo', this.dataEditRequest.ipNo);
        formData.append('ipWorkflow', JSON.stringify(this.dataEditRequest.ipWorkflow));
      }
      formData.append('ipPemegangIzin',JSON.stringify(this.pemegangIzin));
      // formData.append('ipNomorIzinKerja',this.nomorIzinKerja);
      formData.append('ipDetailLokasi', this.detailLokasi);
      formData.append('ipJamBerlakuIzin',this.jamBerlakuIzin);
      formData.append('ipJamBerakhirIzin',this.jamBerakhirIzin);
      // formData.append('ipTanggalPelaksanaan',this.startDate);
      formData.append('ipDetailPekerjaan',this.detailPekerjaan);
      formData.append('ipDosimeterTLD',this.dosimeterTLD || "N/A");
      formData.append('ipInspeksiPeralatan',this.inspeksiPeralatan || "N/A");
      formData.append('ipProsedurKerja',this.prosedurKerja || "N/A");
      formData.append('ipAPD',this.APD || "N/A");
      formData.append('ipAPDKhusus',this.APDKhusus || "N/A");
      formData.append('ipIzinBAPETEN',this.izinBAPETEN || "N/A");
      formData.append('ipKompetenKTT',this.kompetenKTT || "N/A");
      formData.append('ipSosialisasiProsedur',this.sosialisasiProsedur || "N/A");
      formData.append('ipPencegahanLain',this.tindakanPencegahan);

      formData.append('ipStatus', this.status);
      formData.append('ipPerusahaan', this.perusahaan );
      formData.append('ipLocation', JSON.stringify(this.selectedLoc) )
      // formData.append('ipLocation', JSON.stringify(this.selectedLoc) );
      formData.append('ipPelaksanaanStart', this.startDate );
      formData.append('ipPelaksanaanEnd', this.endDate );
      formData.append('uploadId', this.uploadId );
      formData.append('ipUser', JSON.stringify(this.dataUsers) );
      formData.append('ipForm', this.formCode);
      
      const config = {
        method: this.edit ? "put" : "post",
        url: `${this.API_URL}/v1/requests`,
        headers: {"Content-Type": "multipart/form-data", "Authorization": `Bearer ${this.$store.state.token}`},
        data: formData
      };
      axios(config).then(res => {
        this.$store.commit("temporaryData", res);
        this.$router.push("/my-permit");
      });
    },
    // upload(name, paramFile){
    //   if(paramFile == undefined) return ;
    //   if(paramFile.size > 10000000){
    //     paramFile = null;
    //     if(name == 'docPendukung'){
    //       this.docPendukung = this.emptyUpload;
    //     }else if(name == 'docAlat'){
    //       this.docAlat = this.emptyUpload;
    //     }
    //     return
    //   }else{
    //     let formData = new FormData();
    //     formData.append('uploadId', this.uploadId );
    //     formData.append(name, paramFile );
    //     axios.post(`${this.API_URL}/v1/requests/attachment/${name}`, formData, {headers: {"Authorization": `Bearer ${this.$store.state.token}`}});
    //   }      
    // },
    deleteDocPendukung(name){
      let id = this.uploadId.toString();      
      this.$store
        .dispatch("deleteFile", {
          uploadId: id,
          folderName: name,
        })
        .then(() => {
          this.docPendukung = null;
        })
        .catch(() => {
          this.$snackbar.showMessage({ message: "Delete failed!", color: 'red' });
        });
    },
    backHome(){
      this.$router.push("/my-permit");
    },
    backStep(){
      this.e1--
    },
    docName(name){
      return this.$setFilename(name);
    }
  },
  watch: {
    docPendukung(params){
      if(params && params.size < 10000000){
         let formData = new FormData();
        formData.append('uploadId', this.uploadId );
        formData.append('docPendukung', params );
        axios.post(`${this.API_URL}/v1/requests/attachment/docPendukung`, formData, {headers: {"Authorization": `Bearer ${this.$store.state.token}`}});
      }
    },
    dataEditRequest: async function() {
      this.perusahaan = this.dataEditRequest.ipPerusahaan;
      // for (const item of this.locations) {
      //   let checked = false
      //   for (const element of this.dataEditRequest.ipLocation) {
      //     if(item.name == element.name) checked = true
      //   } 
      //   if(checked) this.lokasi.push(true)
      //   else this.lokasi.push(false)
      // }
      this.lokasi = [];
      for(const loc of this.dataEditRequest.ipLocation) {
        this.lokasi.push(loc.name);
      }
      this.pemegangIzin = this.dataEditRequest.ipPemegangIzin;
      // this.nomorIzinKerja = this.dataEditRequest.ipNomorIzinKerja;
      this.dosimeterTLD = this.dataEditRequest.ipDosimeterTLD;
      this.inspeksiPeralatan = this.dataEditRequest.ipInspeksiPeralatan;
      this.APD = this.dataEditRequest.ipAPD;
      this.jamBerlakuIzin = this.dataEditRequest.ipJamBerlakuIzin;
      this.jamBerakhirIzin = this.dataEditRequest.ipJamBerakhirIzin;
      // this.startDate = this.dataEditRequest.ipTanggalPelaksanaan;
      this.detailPekerjaan = this.dataEditRequest.ipDetailPekerjaan;
      this.prosedurKerja = this.dataEditRequest.ipProsedurKerja;
      this.APDKhusus = this.dataEditRequest.ipAPDKhusus;
      this.izinBAPETEN = this.dataEditRequest.ipIzinBAPETEN;
      this.kompetenKTT = this.dataEditRequest.ipKompetenKTT;
      this.sosialisasiProsedur = this.dataEditRequest.ipSosialisasiProsedur;
      this.tindakanPencegahan = this.dataEditRequest.ipPencegahanLain;
      
      this.startDate = this.formatDate(this.dataEditRequest.ipPelaksanaanStart).slice(0,10);
      this.endDate = this.formatDate(this.dataEditRequest.ipPelaksanaanEnd).slice(0,10);
      this.uploadId = this.dataEditRequest.uploadId;
      this.docPendukung = this.dataEditRequest.ipAttachmentFiles.docPendukung;
      this.detailLokasi = this.dataEditRequest.ipDetailLokasi;
    },
  }
};
</script>

<style>
.ck-editor__editable {
    min-height: 300px;
    max-height: 300px;
    resize:none;
}
</style>
